import { useEffect } from 'react';

// Click-to-expand modal for product thumbnails. Pass a product object (with
// sku/name/description) to open; pass null to stay closed.
export default function ProductImageModal({ product, onClose }) {
  useEffect(() => {
    if (!product) return;
    const onKey = e => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    // Lock body scroll while open
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [product, onClose]);

  if (!product) return null;

  return (
    <div style={styles.overlay} onClick={onClose} role="dialog" aria-modal="true">
      <div style={styles.content} onClick={e => e.stopPropagation()}>
        <button style={styles.close} onClick={onClose} aria-label="Close">×</button>
        <img
          src={`/images/products/${product.sku}.jpg`}
          alt={product.name || ''}
          style={styles.image}
        />
        <div style={styles.caption}>
          <div style={styles.name}>{product.name}</div>
          <div style={styles.meta}>
            {product.sku && <span>SKU {product.sku}</span>}
            {product.brand && <span>{product.brand}</span>}
          </div>
          {product.description && (
            <div style={styles.description}>{product.description}</div>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000, padding: '2rem', cursor: 'zoom-out',
  },
  content: {
    background: '#fff', borderRadius: 10, padding: '1.25rem',
    maxWidth: 'min(92vw, 520px)', maxHeight: '90vh',
    display: 'flex', flexDirection: 'column', gap: '1rem',
    position: 'relative', cursor: 'default', overflow: 'auto',
  },
  close: {
    position: 'absolute', top: '0.5rem', right: '0.75rem',
    background: 'none', border: 'none', fontSize: '1.5rem',
    color: 'rgba(0,0,0,0.5)', cursor: 'pointer', lineHeight: 1,
    padding: '0.25rem 0.5rem',
  },
  image: {
    display: 'block', maxWidth: '100%',
    maxHeight: '60vh', objectFit: 'contain',
    margin: '0.5rem auto', background: '#f7f5f2', borderRadius: 6,
  },
  caption: { display: 'flex', flexDirection: 'column', gap: '0.4rem', paddingTop: '0.25rem' },
  name: { fontSize: '1rem', fontWeight: 600, color: '#333' },
  meta: { display: 'flex', gap: '0.75rem', fontSize: '0.8rem', color: 'rgba(0,0,0,0.55)', fontFamily: 'monospace' },
  description: { fontSize: '0.85rem', color: 'rgba(0,0,0,0.55)', lineHeight: 1.5 },
};
